import { types } from "./types";
import { metadataPagePath, metadataSectionId } from "./constants";

const stringToHTML = function (str) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  return doc.body;
};

const getMetaUrl = function () {
  const url = new URL(`${window.location.origin}${metadataPagePath}`);
  url.searchParams.append("sections", metadataSectionId);

  return {
    metadataSectionId,
    url,
  };
};

export const actions = {
  fetchMeta({ commit }) {
    try {
      requestIdleCallback(
        async () => {
          const { metadataSectionId, url } = getMetaUrl();

          const data = await fetch(url, { method: "GET" }).then((response) =>
            response.json()
          );
          const dom = stringToHTML(data[metadataSectionId]);

          let variants;
          let products;
          let globals;

          try {
            const jsonVariants = JSON.parse(
              dom.querySelector(".js-variants").innerHTML
            );
            variants = jsonVariants.variants;
          } catch (e) {
            variants = [];
          }

          try {
            const jsonProducts = JSON.parse(
              dom.querySelector(".js-products").innerHTML
            );
            products = jsonProducts.products;
          } catch (e) {
            products = [];
          }

          try {
            const jsonGlobals = JSON.parse(
              dom.querySelector(".js-global").innerHTML
            );
            globals = jsonGlobals;
          } catch (e) {
            globals = {};
          }

          commit(types.UPDATE_METAFIELDS_VARIANTS, variants);
          commit(types.UPDATE_METAFIELDS_PRODUCTS, products);
          commit(types.UPDATE_METAFIELDS_GLOBALS, globals);
        },
        { timeout: 3000 }
      );
    } catch (error) {
      console.log(error);
    }
  },
};
